import { BillingItemResource } from '../../../Entities/BillingItem';
import { MerchantResource } from '../../../Entities/Merchant';
import { PaymentResource } from '../../../Entities/Payment';
import { idFrom } from '../../../utils';

const GST_RATE = 0.1; // 10%
const GST_MULTIPLIER = 1 + GST_RATE;

export default function billingItemsToPayment(
  billingItems: BillingItemResource[],
  merchants: MerchantResource[],
): Partial<PaymentResource> {
  const merchantIds = billingItems.map((item) => idFrom(item, 'merchant'));
  const merchantId = merchantIds.length > 0 ? merchantIds[0] : null;

  const isForeignCustomer =
    merchants.find((m) => m.id === merchantId)?.attributes.is_foreign_company ?? false;

  const shouldPayGST = !isForeignCustomer;

  const baseAmount = billingItems.reduce((sum, item) => sum + (item.attributes.amount ?? 0), 0);
  const amount = shouldPayGST ? baseAmount * GST_MULTIPLIER : baseAmount;

  return {
    type: 'payments',
    attributes: { amount, currency: 'AUD' },
    relationships: {
      billing_items: {
        data: billingItems.map((billingItem) => ({
          id: billingItem.id,
          type: 'billing_items',
        })),
      },
    },
  };
}
